import { resultCount, resultNumber } from "./resultPresentation.ts";
import type { RecordValue } from "./types.ts";

export type StagePageRead = (cursor: string, signal: AbortSignal) => Promise<RecordValue>;

/** Explicit presenter action only. Pin one authorized snapshot and never show a partial podium. */
export async function loadStageSnapshot(unitId: string, snapshotId: string, read: StagePageRead, signal: AbortSignal): Promise<RecordValue> {
  const rows: RecordValue[] = [];
  const entries = new Set<string>(); const cursors = new Set<string>();
  let cursor = ""; let first: RecordValue | undefined;
  for (let page = 0; page < 10; page++) {
    signal.throwIfAborted();
    const data = await read(cursor, signal);
    signal.throwIfAborted();
    if (data.unitId !== unitId || data.snapshotId !== snapshotId || !Array.isArray(data.items) ||
        resultCount(data.totalCount) === null || Number(data.totalCount) > 1000 || typeof data.published !== "boolean") throw new Error("STAGE_SNAPSHOT_INCOMPLETE");
    if (!first) first = data;
    if (data.totalCount !== first.totalCount || data.published !== first.published || data.configVersion !== first.configVersion) throw new Error("STAGE_SNAPSHOT_CHANGED");
    for (const value of data.items) {
      if (!value || typeof value !== "object" || Array.isArray(value)) throw new Error("STAGE_SNAPSHOT_INVALID");
      const row = value as RecordValue;
      const score = resultNumber(row.score);
      if (typeof row.entryId !== "string" || !row.entryId || entries.has(row.entryId) ||
          resultCount(row.rank) === null || Number(row.rank) < 1 || score === null || score > 100) throw new Error("STAGE_SNAPSHOT_INVALID");
      entries.add(row.entryId); rows.push(row);
    }
    if (rows.length > 1000 || rows.length > Number(data.totalCount)) throw new Error("STAGE_SNAPSHOT_INCOMPLETE");
    if (!data.nextCursor) {
      if (rows.length !== data.totalCount) throw new Error("STAGE_SNAPSHOT_INCOMPLETE");
      return { ...first, items: rows, nextCursor: null };
    }
    if (!data.items.length || typeof data.nextCursor !== "string" || cursors.has(data.nextCursor)) throw new Error("STAGE_SNAPSHOT_INCOMPLETE");
    cursor = data.nextCursor; cursors.add(cursor);
  }
  throw new Error("STAGE_SNAPSHOT_LIMIT");
}

/** Keep every stored rank-one entry, including ties. No score comparison or reranking in the client. */
export function stageWinners(rows: RecordValue[]) { return rows.filter(row => row.rank === 1); }
